<template>
  <div v-if="broker != null && user != null">

    <PageHeader label="Multi-Factor Authentication" />
    
    <div class="my-8">

      <div class="inline-block p-4 bg-red-100 border border-red-500 text-sm" v-if="broker.phone_mobile == null">
        Please make sure you 
        
        <router-link
          :to="{
            name: 'broker-account',
            params : {
              brokerId : $route.params.brokerId
            }
          }"
          tag="a"
          class="underline">save a valid mobile phone number in your profile</router-link>

        before enabling the Multi-Factor Authentication.
      </div>

      <div class="label-line label-standard">Enable Multi-Factor Authentication</div>

      <div class="form-line ml-1 flex items-center">
        <input type="radio" name="input-mfa-enabled" v-model="user.mfa_enabled" :value="1" id="input-mfa-enabled-yes" :disabled="broker.phone_mobile == null" />
        <label class="text-sm ml-2 mr-8" for="input-mfa-enabled-yes">Yes</label>

        <div class="text-sm text-gray-700" v-if="user.mfa_verified_at != null">
          MFA was enabled and verified on {{ user.mfa_verified_at }}.
        </div>
      </div>

      <div class="form-line ml-1 flex items-center">
        <input type="radio" name="input-mfa-enabled" v-model="user.mfa_enabled" :value="0" id="input-mfa-enabled-no" :disabled="broker.phone_mobile == null" />
        <label class="text-sm ml-2" for="input-mfa-enabled-no">No</label>
      </div>

      <div class="mt-12" v-if="broker.phone_mobile != null">
        <SubmitButton :onClick="submit" :loading="loading" />
      </div>
    </div>

    <MFAConfirmModalOne :sendMFAVerificationCode="sendMFAVerificationCode" />
    <MFAConfirmModalTwo :sendMFAVerificationCode="sendMFAVerificationCode" />
    <MFAConfirmModalThree />
  </div>
</template>

<script>
  import { EventBus }         from '@/shared/event-bus'
  import PageHeader           from '@/shared/components/headers/PageHeader'
  import SubmitButton         from '@/shared/components/form/SubmitButton'
  import MFAConfirmModalOne   from './MFAConfirmModalOne'
  import MFAConfirmModalTwo   from './MFAConfirmModalTwo'
  import MFAConfirmModalThree from './MFAConfirmModalThree'

  export default {

    components: {
      PageHeader,
      SubmitButton,
      MFAConfirmModalOne,
      MFAConfirmModalTwo,
      MFAConfirmModalThree
    },

    data () {
      return {
        loading: false,
        user   : _.cloneDeep(this.$store.state.user),
        broker : _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker),
      }
    },

    mounted() {
      EventBus.$on('refresh-user', () => {
        this.getUser({
          force : true
        }, (user) => {
          this.user = _.cloneDeep(user)
        })
      })
    },

    methods : {

      sendMFAVerificationCode(callback) {
        this.apiPost({}, 'auth/send-mfa-verification-code', (data) => {
          callback(data)
        })
      },

      submit() {

        let valid = true

        if(valid) {

          if(!this.user.mfa_enabled && this.$store.state.user.mfa_enabled) {
            this.confirmDisable()
          }

          else {
            this.reallySubmit()
          }
        }
      },

      reallySubmit() {
        this.loading = true
        this.apiPost({
          userId    : this.user.id,
          mfaEnabled: this.user.mfa_enabled
        }, 'user/mfa-enabled', (data) => {
          this.loading = false

          if(data.confirm) {
            this.$modal.show('mfa-confirm-modal-one')
          }

          else {
            EventBus.$emit('refresh-user')
            EventBus.$emit('notification-event', {
              'type'   : 'success', 
              'message': 'Settings saved successfully.'
            })
          }        
        })
      },

      confirmDisable() {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to turn off Multi-Factor Authentication?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.$modal.hide('confirm-modal')
              this.reallySubmit()
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.user.mfa_enabled = 1
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      }
    },
  }
</script>